import { render, staticRenderFns } from "./RecruiterAiInterviewDetailsCard.vue?vue&type=template&id=cc3660d2&scoped=true"
import script from "./RecruiterAiInterviewDetailsCard.vue?vue&type=script&lang=ts"
export * from "./RecruiterAiInterviewDetailsCard.vue?vue&type=script&lang=ts"
import style0 from "./RecruiterAiInterviewDetailsCard.vue?vue&type=style&index=0&id=cc3660d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3660d2",
  null
  
)

export default component.exports